import { Cms, SubPage, accountTemplate, accountTemplateCol, Template, UserCredential } from './../models/cms.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CompleterData, CompleterService, CompleterItem, CompleterCmp } from 'ng2-completer';
import { MyAccountService } from '../../services/myAccount.service';
import { CmsStudioService } from '../cms-studio.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2'
import { Observable } from 'rxjs';
import { AccountContact } from '../../models/Profile-view.model';
import { CommonService } from '../../services';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';

@Component({
  selector: 'app-cms-access',
  templateUrl: './cmsaccess.component.html',
  styleUrls: ['./cmsaccess.component.css'],
})

export class CmsAccessComponent implements OnInit {
  title: string = "CMS - Access";
  isManageOwners = false;
  isManageCont = false;

  activeMasterCMS: Array<Cms> = [];
  originalMasterCMS: Array<Cms> = [];
  selectedCMS: Cms;
  users: Array<UserCredential> = [];
  dsContactList: CompleterData;
  contactData: Array<Object> = new Array<Object>();
  contactList: Array<AccountContact> = new Array<AccountContact>();

  // searchOwnerUsers: Array<UserCredential> = [];
  // searchContrUsers: Array<UserCredential> = [];
  searchOwnerUsers: Array<AccountContact> = [];
  searchContrUsers: Array<AccountContact> = [];
  //user: UserCredential;
  currentUserModel: CurrentUserModel;
  constructor(private router: Router, private ngProgress: NgProgress, private activeRouter: ActivatedRoute,
    private cmsStudioService: CmsStudioService, private accountService: MyAccountService, private modalService: NgbModal, 
    private commonService: CommonService, private authService: AuthService) { }

  ngOnInit() {
    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
    this.getAllActiveMasterCms();
    // var accountId = this.commonService.readCookie('AccountId')
    // if(!accountId)accountId = '';
    var accountId = '';
    this.accountService.GetAccountUserList(accountId).subscribe(
      (result: Array<AccountContact>) => {
        this.contactList = result.filter(x => x.out_login_id != '');
        this.searchOwnerUsers = this.contactList;
        this.searchContrUsers = this.contactList;
      });
    });
  }

  addUser(role, usr) {
    //console.log(role);
    //console.log(usr);
    if (role == 'owner') {
      if (!this.selectedCMS.owners) this.selectedCMS.owners = [];

      if (this.selectedCMS.owners.findIndex(ow => ow.userName.toLowerCase() == usr.out_login_id.toLowerCase()) < 0) {
        var user = new UserCredential();
        user.accountId = usr.out_accountcode;
        user.userName = usr.out_login_id;
        this.selectedCMS.owners.push(user);
      }
    }
    if (role == 'contr') {
      if (!this.selectedCMS.contributors) this.selectedCMS.contributors = [];

      if (this.selectedCMS.contributors.findIndex(ow => ow.userName.toLowerCase() == usr.out_login_id.toLowerCase()) < 0)
        var user = new UserCredential();
      user.accountId = usr.out_accountcode;
      user.userName = usr.out_login_id;
      this.selectedCMS.contributors.push(user);
    }
  }

  removeUser(role, index) {
    console.log("inside removeSubpage");
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: '#ffaa00',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      console.log(result);
      if (result.value) {
        if (role == 'owner') this.selectedCMS.owners.splice(index, 1);
        if (role == 'contr') this.selectedCMS.contributors.splice(index, 1);
      }
    })
  }

  getAllActiveMasterCms() {
    this.cmsStudioService.getAllActiveMasterCms(this.currentUserModel.companyCode)
      .subscribe(res => {
        //console.log(res);
        this.activeMasterCMS = res.cms;
        this.originalMasterCMS = this.activeMasterCMS
      })
  }

  saveCms() {
    this.cmsStudioService.createOrUpdateCms(this.selectedCMS)
      .subscribe(res => {
        console.log(res);
        this.commonService.showSuccess("#saveButton", "Saved successfully", "right");
        this.getAllActiveMasterCms();
      });
  }

  searchCMS(e) {
    var search = e.target.value;
    if (search) search = search.toLowerCase();
    if (search && search != '') {
      this.activeMasterCMS = this.originalMasterCMS.filter(ur => {
        return (ur.title.toLowerCase().includes(search));
      })
    } else {
      this.activeMasterCMS = this.originalMasterCMS;
    }
  }

  searchUser(role, e) {
    var searchquery = e.target.value;
    if (searchquery) searchquery = searchquery.toLowerCase();

    console.log(searchquery);
    if (role == 'owner') {
      this.searchOwnerUsers = [];
      if (searchquery && searchquery != '') {
        this.contactList.forEach(ur => {
          if (ur.out_first_name.toLowerCase().includes(searchquery) || ur.out_surname.toLowerCase().includes(searchquery) || ur.out_login_id.toLowerCase().includes(searchquery))
            this.searchOwnerUsers.push(ur)
        })
      } else if (searchquery === '') {
        this.searchOwnerUsers = this.contactList;
      }
    }
    if (role == 'contr') {
      this.searchContrUsers = [];
      if (searchquery && searchquery != '') {
        this.contactList.forEach(ur => {
          if (ur.out_first_name.toLowerCase().includes(searchquery) || ur.out_surname.toLowerCase().includes(searchquery) || ur.out_login_id.toLowerCase().includes(searchquery))
            this.searchContrUsers.push(ur)
        })
      } else if (searchquery === '') {
        this.searchContrUsers = this.contactList;
      }
    }
  }

  checkIfExists(role, usr) {
    debugger;
    var ret = false;
    if (role == 'owner') {
      if (this.selectedCMS.owners)
        if (this.selectedCMS.owners.findIndex(ow => ow.userName == usr.out_login_id) >= 0 &&
          this.selectedCMS.owners.findIndex(ow => ow.accountId == usr.out_accountcode) >= 0)
          ret = true;
    }
    if (role == 'contr') {
      if (this.selectedCMS.contributors)
        if (this.selectedCMS.contributors.findIndex(ow => ow.userName == usr.out_login_id) >= 0 &&
          this.selectedCMS.contributors.findIndex(ow => ow.accountId == usr.out_accountcode) >= 0)
          ret = true;
    }
    return ret;
  }
}

